export default "__VITE_ASSET__85ebf257__"